import _ from 'lodash';

let nextID = 0;

const aLobJob = {
    productCode: undefined,
    producerCode: undefined,
    coveragePartType: undefined,
    postalCode: undefined,
    periodStart: undefined,
    stateCode_ML: undefined,
    offeringCode_ML: undefined,
    /**
         * From the new quote dialog, existing saved quotes can be chosen
         * to add to a bundle. Similarly, existing policies on the account
         * can also be chosen.
         */
    jobNumber: undefined,
    policyNumber: undefined,
    isBeforeQuoteCompleted: false,
    isAfterQuoteCompleted: false,
    isPaymentDetailsCompleted: false,
    isESignatureCompleted: false,
    quoteTag: undefined,
    quoteTypeName: undefined,
    lastVisitedStep: undefined,
    completedSteps: []
};

function LobJob(data) {
    data.priority = () => {
        switch (this.productCode) {
            case 'PersonalAuto':
                return 1;
            case 'HOPHomeowners':
                return 2;
            case 'PersonalUmbrella':
                return 3;
            default:
                return undefined;
        }
    };

    if (data) {
        const formattedData = Object.assign({}, aLobJob, data);

        _.extend(this, formattedData);

        this.id = nextID;
        nextID += 1;
    }
}

export default LobJob;
